import { Component, OnInit } from '@angular/core';
import { AccessService } from 'src/app/shared/services/access.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  routingNum: string;
  constructor(public accessApi: AccessService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.routingNum = params.get('routingNum');
    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      jQuery('.app .side-nav').addClass('hidden');
      jQuery('.app .page-container').addClass('no-pdd-left');
      jQuery('.app .header').toggleClass('hidden');
    }, 100);
  }
}
